import { ReactElement } from 'react'

import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { Icon } from 'components/core'
import { getPath } from 'routing/pagePaths'

import { NavButton } from './NavButton'

export const InsightsNavItem = (): ReactElement | null => {
    const { t } = useTranslation('common')

    const navigate = useNavigate()

    return (
        <NavButton
            onClick={() => navigate(getPath('insightsPage'))}
            tooltipText={t('common:Insights', 'Insights')}
        >
            <Icon name="STARS_TWINKLE" size={18} />
        </NavButton>
    )
}
